import type { CaptionCue } from '../../services/studioService';

/**
 * The cue playing at `ms`, or null in a gap.
 *
 * A copy of the server's own `cueAt` rather than a shared import: the web layer never reaches into the api
 * layer, and this is four lines of arithmetic over a shape both sides already agree on. The rule it holds is
 * the interesting part — a cue is live from its start UP TO its end, never at its end, so two adjacent lines
 * cannot both be on screen for the instant they touch.
 */
export function cueAt(cues: CaptionCue[] | null | undefined, ms: number): CaptionCue | null {
  if (!cues?.length) return null;
  return cues.find((c) => ms >= c.from_ms && ms < c.to_ms) || null;
}
